import {Component, Input} from '@angular/core';
import {TableModule} from 'primeng/table';
import {CommonModule} from '@angular/common';
import {Panel, PanelModule} from 'primeng/panel';


type ThemeData = {
  id?: string;
  name?: string;
  version?: string;
  isChild?: boolean;
  parentTheme?: string;
  newVersion?: string;
  currentImageSrc?: string;
  path?: string;
}

@Component({
  selector: 'app-theme-details',
  standalone: true,
  imports: [TableModule, CommonModule, PanelModule],
  templateUrl: './theme-details.component.html',
  styleUrl: './theme-details.component.css'
})
export class ThemeDetailsComponent {
  @Input() themesData: ThemeData[] = [];

  fallbackImage: string = '/images/notfound.png';

  ngOnChanges() {
    if (!this.themesData) {
      return;
    }


    this.themesData = this.themesData.map((theme, i) => {
      return {
        ...theme,
        id: `${i}_${Math.random().toString(36).substr(2, 9)}`,
        currentImageSrc: `${theme?.path}/screenshot.png`
      }
    });
  }


  trackByThemeId(index: number, theme: any): string {
    return theme.id;
  }

  themesFound() {
    return this.themesData && this.themesData.length > 0;
  }

  handleImageError(theme: ThemeData): void {
    if (!theme) return;

    // Attempt to switch from PNG to JPG
    if (theme.currentImageSrc?.endsWith('screenshot.png')) {
      theme.currentImageSrc = `${theme.path}/screenshot.jpg`;
    }
    // If JPG also fails, set to fallback image
    else if (theme.currentImageSrc?.endsWith('screenshot.jpg')) {
      theme.currentImageSrc = this.fallbackImage;
    }
    // If fallback also fails, you can set a default fallback or leave it blank
    else {
      theme.currentImageSrc = this.fallbackImage; // Optional: set to a default image
    }
  }
}
